import React from 'react';
import { connect } from 'react-redux';
import GeneralAggregationChart from '../../SystemDashboard/GeneralAggregationChart';
import { yaxis_count, yaxis_double } from '../../../../../constants';
import { getColorById, getOnlyUnique, getPercentage, isDefined, getXaxisCategories, arrayIsNotEmpty } from '../../../../../utils';
import GeneralChart from "../GeneralChart.jsx";

class GeneralAggregationChartWithExternalLegendWithCountContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notVisibleAggregationName: []
        };
        this.toggleDataSeries = this.toggleDataSeries.bind(this);
        this.getValueForDate = this.getValueForDate.bind(this);
    }

    toggleDataSeries(e) {
        if (this.state.notVisibleAggregationName.includes(e.dataSeries.name)) {
            this.state.notVisibleAggregationName = this.state.notVisibleAggregationName.filter(item => item !== e.dataSeries.name);
        }
        else {
            this.state.notVisibleAggregationName.push(e.dataSeries.name);
        }

        this.setState({ reactUpdater: !this.state.reactUpdater });
    }

    getValueForDate(valueType, itemCurrentDateStats) {
        if (!isDefined(itemCurrentDateStats)) {
            return undefined;
        }
        if (valueType === "ticketCount") {
            const value = itemCurrentDateStats.tickets;
            return value;
        }
        else if (valueType === "overalSuccessRatePercent") {
            const medValue = itemCurrentDateStats.overalSuccessRatePercent;
            return medValue;
        }
        else if (valueType === "yesResponsePercentage") {
            const yesCountPercentage = getPercentage(itemCurrentDateStats.effectiveResponseCntRounded, itemCurrentDateStats.sumQuestionEffectiveResponses);
            return yesCountPercentage;
        }
    }

    render() {
        const { allItemsBreakdownOverTimeStats, chartType, questionCode, valueType, hideLegend, itemIdsActiveInLegend } = this.props;

        if (!allItemsBreakdownOverTimeStats || !Array.isArray(allItemsBreakdownOverTimeStats)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }
        else if (allItemsBreakdownOverTimeStats.length == 0) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                No data
            </div>;
        }

        let data = [];

        let maxDateIndex = allItemsBreakdownOverTimeStats.reduce((max, obj) => {
            return obj.dateIndex > max ? obj.dateIndex : max;
        }, -Infinity);

        const responseForQuestionBreakdownOverTimeStats = allItemsBreakdownOverTimeStats.filter(r => r.questionCode === questionCode
            && itemIdsActiveInLegend.some(itemId => itemId == r.aggregationId));

        const itemsName = responseForQuestionBreakdownOverTimeStats.map(p => p.aggregationName).filter(getOnlyUnique);
        itemsName.forEach(ch => {
            let itemAllDatesDataWithDesiredResponses = responseForQuestionBreakdownOverTimeStats.filter(p => p.aggregationName === ch);

            if (valueType === "yesResponsePercentage") {
                itemAllDatesDataWithDesiredResponses = itemAllDatesDataWithDesiredResponses.filter(p => p.finalResponse === 'Yes' || p.finalResponse === 'Satisfied' ||
                    p.finalResponse === 'Promoter' || p.finalResponse === 'Detractor');
            }

            let itemDataPoints = [];
            let itemCountDataPoints = [];
            if (this.state.notVisibleAggregationName.includes(ch)) {
                itemDataPoints.push({
                    label: windowStartLabel,
                    y: undefined
                });
            }
            else {
                for (var i = 1; i <= maxDateIndex; i++) {
                    const elementWithCurrentDateIndex = responseForQuestionBreakdownOverTimeStats.find(cbo => cbo.dateIndex === i);
                    if (isDefined(elementWithCurrentDateIndex)) {
                        const windowStart = elementWithCurrentDateIndex.windowStart;
                        if (isDefined(windowStart)) {
                            const windowStartLabel = windowStart.slice(0, 5);

                            if (questionCode === 'NPS') {
                                const itemsWithCurrentDateStats = itemAllDatesDataWithDesiredResponses.filter(cd => cd.dateIndex === i);
                                if (arrayIsNotEmpty(itemsWithCurrentDateStats)) {
                                    const promoter = itemsWithCurrentDateStats.find(v => v.finalResponse === 'Promoter');
                                    const detractor = itemsWithCurrentDateStats.find(v => v.finalResponse === 'Detractor');

                                    const promoterPercentage = isDefined(promoter) ? getPercentage(promoter.effectiveResponseCntRounded, promoter.sumQuestionEffectiveResponses) : 0;
                                    const detractorPercentage = isDefined(detractor) ? getPercentage(detractor.effectiveResponseCntRounded, detractor.sumQuestionEffectiveResponses) : 0;
                                    if (isDefined(promoterPercentage) && isDefined(detractorPercentage)) {
                                        itemDataPoints.push({
                                            label: windowStartLabel,
                                            y: promoterPercentage - detractorPercentage
                                        });
                                    }

                                    itemCountDataPoints.push({
                                        label: windowStartLabel,
                                        y: itemsWithCurrentDateStats[0].sumQuestionEffectiveResponses
                                    })
                                }
                            }
                            else {
                                const itemWithCurrentDateStats = itemAllDatesDataWithDesiredResponses.find(cd => cd.dateIndex === i);
                                if (isDefined(itemWithCurrentDateStats)) {
                                    const itemCurrentDateValue = this.getValueForDate(valueType, itemWithCurrentDateStats);
                                    itemDataPoints.push({
                                        label: windowStartLabel,
                                        y: itemCurrentDateValue
                                    });

                                    itemCountDataPoints.push({
                                        label: windowStartLabel,
                                        y: itemWithCurrentDateStats.sumQuestionEffectiveResponses
                                    })
                                }
                            }
                        }
                    }
                }
            }

            const a = {
                type: chartType,
                name: isDefined(ch) ? ch : 'None',
                yAxis: 1,
                showInLegend: !hideLegend,
                yValueFormatString: "#,###",
                dataPoints: itemDataPoints,
                color: getColorById(arrayIsNotEmpty(itemAllDatesDataWithDesiredResponses) ? itemAllDatesDataWithDesiredResponses[0].aggregationId : undefined)
            };
            data.push(a);

            const itemCountData = {
                type: "column",
                axisYType: "secondary",
                color: getColorById(arrayIsNotEmpty(itemAllDatesDataWithDesiredResponses) ? itemAllDatesDataWithDesiredResponses[0].aggregationId : undefined),
                name: 'Hybrid Count',
                name: isDefined(ch) ? `${ch} count` : 'None',
                showInLegend: false,
                yValueFormatString: "#,###",
                dataPoints: itemCountDataPoints
            };
            data.push(itemCountData);
        });

        return (
            <>
                <GeneralChart
                    yAxis={yaxis_double}
                    series={data}
                    showLegends={true}
                    xAxisCategories={[...getXaxisCategories(data)]}
                />
            </>
        );
    }
}

const select = state => ({});

export default connect(select)(GeneralAggregationChartWithExternalLegendWithCountContainer);